module.exports = __webpack_public_path__ + "media/assets/images/profit-loss-polyline-8a1d9d084254045788f3ae0b6db9440e.svg";